<template>
  <div class="snail_hlw_help_page">
    <!-- 活动标题 -->
    <div v-wechat-title="'最强蜗牛-爷（蜗）爷，你关注的神域终于更新啦！'"></div>
    <!-- 首页进入青瓷游戏LOGO -->
    <transition enter-active-class='animated fadeIn' leave-active-class='animated fadeOut' name='fade'>
      <div @touchmove.prevent class='preloading preloading-snail' v-show='preloadingShow'></div>
    </transition>
    <div class="snail-hlw-help-content">
      <div class="title"></div>
      <div class="btn-all">
        <a class="l-btn" href="javascript:;" @click="joinTeam()"></a>
        <a class="r-btn" href="javascript:;" @click="goHomeLink()"></a>
      </div>
    </div>

    <Header :config="headerConfig" :isShowInfo="true" :isOnline="1" />

    <!-- 登录弹窗 -->
    <Login v-if="isShowLogin" v-on:channelCallback="selectCallback" :gameName="gameName" :loginTypes="loginTypes"
      :downloadUrl="downloadUrl" channelTips="角色UID可在游戏中—设置—UID查看" noAuthLogin></Login>
    <Os v-if="isShowOs" v-on:selectCallback="selectCallback" v-on:logoutCallback="osCancell" :gameName="gameName"></Os>

    <!-- 组队弹窗 -->
    <div :class="'team-up-wrap popup_wrap team-up-wrap-' + teamUpShow" v-show="teamUpShow">
      <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" :duration="{ enter: 1000 }">
        <div class="team-up-box popup_wrap-box" v-show="teamUpShow">
          <div class="info-box">
            <p>您已成功加入【<span>{{ help_name }}</span>】组建的队伍，快去专题页查看奖励吧！</p>
          </div>
          <a class="confirm-btn" href="javascript:;" @click="goHomeLink()"></a>
        </div>
      </transition>
      <div class="close-bg" v-show="teamUpShow" @click="popSwitch('teamUpShow', false)"></div>
    </div>

    <!-- 全局遮罩 -->
    <div @touchmove.prevent :class="'prevent-wrap prevent-wrap-' + preventShow"></div>
  </div>
</template>




<script>
import Header from '@/components/Header/index';
import Footer from "@/components/Footer";
import { headerConfig } from "../headerConfig";
import { Toast, Indicator } from 'mint-ui';
import { mapState, mapMutations, mapActions } from 'vuex';
import Os from '@/components/os';
import Login from '@/components/login';
import { onHelpGetInitDataAPI, joinTeamDataAPI } from '../api';
import { buriedLogger, analysisParams, getTimeStamp } from '@/utils/utils';

export default {

  name: 'hlw-help',
  components: {
    Header,
    Footer,
    Login,
    Os
  },
  data() {
    return {
      headerConfig,
      noSwiperClass: '', // swiper-no-swiping
      gameName: "snail",
      loginTypes: ["sms", "password", "channel"],
      downloadUrl: 'http://snail.qingcigame.com/official/',
      preventShow: false,
      preloadingShow: true,
      titleShow: false,
      enterLink: '',
      friendId: '',
      help_name: '',

      active_Info: {}, // 活动信息
      user_info: {}, // 用户信息

      teamUpShow: false,
    };
  },
  created() {
    const { protocol, host } = window.location;
    const params = analysisParams(window.location.href);
    this.friendId = params.friend_id;
    
    setTimeout(() => {
      // 帮助页面初始化
      this.onHelpIntState();
      this.preloadingShow = false;
    }, 100);
  },
  mounted() {
    this.$nextTick(() => {

      // 分享
      const { protocol, host } = window.location;
      this.enterLink = `${protocol}//${host}/snail/hlw/enter${getTimeStamp()}`;
      const pcLink = `${protocol}//${host}/snail/hlw/pc`;
      this.monitoringEquipment(pcLink);
      this.isSetShare( this.enterLink );

      // 埋点
      const bl = buriedLogger('snail', '蜗牛_神域_葫芦娃h5_助力页');
      this.logger = bl;
      setTimeout(() => {
        this.logger.sum('蜗牛_神域_葫芦娃h5_助力页_活动页统计');
      }, 200);
    })
  },
  computed: {
    ...mapState([
      'userInfo',
      'activeInfo',
      'isShowLogin',
      'isShowOs'
    ])
  },
  watch: {
    userInfo: {
      handler(newValue, oldValue) {
        console.log('newValue', newValue);
        console.log('oldValue', oldValue);
        if (!newValue.share_account) {
          // TAG: 注销的时候
        } else if (newValue.share_account !== oldValue.share_account) {
          // TAG: 初始登陆/切换角色的时候
          this.onHelpIntState();
        }
      }
    }
  },
  methods: {
    monitoringEquipment (pcLink) {
      if (!navigator.userAgent.match(/(iPhone|iPod|Android|ios)/i)) location.href = pcLink;
    },
    // 微信分享
    isSetShare(linkUrl) {
      this.setShare({
        link: linkUrl + `${getTimeStamp()}`,
        title: '爷（蜗）爷，你关注的神域终于更新啦！',
        imgUrl: 'https://download4.qcplay.com/qcgame-api/Hmpg68XTBbVFL9n0HyLdNp48EdiWf8mCBSx2naIz.png',
        desc: '快来跟蜗一起，揭开神域的层层真相！',
      })
    },
    // 返回专题页
    goHomeLink() {
      this.logger.sum('蜗牛_神域_葫芦娃h5_助力页_前往专题页按钮');
      window.location.href = this.enterLink;
    },
    // 加入队伍
    joinTeam() {
      if (this.user_info.share_account === undefined || this.user_info.share_account === '') {
        this.changeLoginPopup(true);
        return
      }
      joinTeamDataAPI({ friend_id: this.friendId }).then(response => {
        if (response.code === 200) {
          console.log(response)
          this.popSwitch('teamUpShow', true);
        } else {
          this.onToast(response.message);
        }
      }).catch(() => {
        this.preloadingShow = false;
        this.titleShow = true;
      });
    },
    // 获取用户信息
    onHelpIntState() {
      onHelpGetInitDataAPI({ friend_id: this.friendId }).then(response => {
        const { code } = response || {}
        this.preloadingShow = false;
        this.titleShow = true;
        if (Number(code) === 200) {
          this.onInitDataCallback(response);
          this.active_Info = response.data.activity || [];
          this.user_info = response.data.user_info || [];
          this.help_name = response.data.activity.help_name;
          return
        }
      }).catch(() => {
        this.preloadingShow = false;
        this.titleShow = true;
      });
    },
    // 弹窗状态-开or关
    popSwitch(name, state) {
      this[name] = state;
    },
    // 清除data里面相关数据
    clearActiveInfo() {

    },
    // 选择角色后
    selectCallback() {
      this.onHelpIntState();
    },
    osCancell() {
      this.active_Info = []
      this.user_info = []
    },
    // TAG: 其他简易封装的方法
    onToast(config) {
      const curConfig = {
        duration: 1000,
        className: 'toasts'
      };
      if (!config) {
        console.error('缺少config参数');
        return false;
      }
      if (typeof config === 'string') {
        curConfig.message = config;
      }
      Toast(curConfig);
    },
    ...mapMutations([
      "changeLoginPopup",
      "changeOsPopup",
      "setInitActiveInfo",
      "setInitUserInfo",
      "setActiveInfo",
      "setLogger"
    ]),
    ...mapActions(["onInitDataCallback", "setShare"])
  }
};
</script>

<style lang="less">
@import url("./index.less");
</style>
 


// WEBPACK FOOTER //
// src/pages/snail/hlw/help/index.vue